import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SetFullNameRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SetFullNameResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const setFullName = (request: SetFullNameRequest, options?: CashRequestOptions) =>
  post<SetFullNameRequest, SetFullNameResponse>('/2.0/cash/set-full-name', request, { ...options, rejectOnError: true })
